var TweetHeaderTemplate = require('./tweet-header.template');
var TweetBodyTemplate = require('./tweet-body.template');
var TweetGalleryTemplate = require('./tweet-gallery.template');
var TweetFooterTemplate = require('./tweet-footer.template');
function escapeAttribute(value) {
  return String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function resolvePresentation() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (options.presentation) {
    return options.presentation;
  }
  if (options.embedded || String(className).includes('embedded')) {
    return 'embedded';
  }
  if (options.focused || String(className).includes('focused')) {
    return 'focused';
  }
  if (options.root || String(className).includes('root')) {
    return 'root';
  }
  if (options.reply || String(className).includes('reply')) {
    return 'reply';
  }
  return 'timeline';
}

/**
 * Public key for detail headers — raw key, never an @handle.
 */
function formatPublicKey() {
  var tweet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = tweet.publicKey != null && String(tweet.publicKey).trim() !== '' ? String(tweet.publicKey).trim() : tweet.handle != null ? String(tweet.handle).trim() : '';
  return key.replace(/^@/, '');
}

/** @deprecated use formatPublicKey — kept for callers that still import formatHandle */
function formatHandle() {
  var tweet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return formatPublicKey(tweet);
}
function resolveHeaderMode(presentation) {
  if (presentation === 'focused') {
    return 'expanded';
  }
  if (presentation === 'compose') {
    return 'compose';
  }
  return 'compact';
}
var _TweetTemplate = function TweetTemplate(tweet) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tweet';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var presentation = resolvePresentation(className, options);
  var embedded = presentation === 'embedded' || options.embedded;
  var allowEmbed = options.allowEmbed !== false && !embedded;
  var hideControls = embedded || options.hideControls || presentation === 'compose' || Boolean(tweet.ephemeral);
  var mode = options.mode || resolveHeaderMode(presentation);

  // Timeline: no key. Detail: public key only (no @). Compose: none.
  var handle = options.handle != null ? String(options.handle).replace(/^@/, '') : mode === 'expanded' ? formatPublicKey(tweet) : '';
  var time = options.time != null ? String(options.time) : tweet.time ? String(tweet.time) : '';
  var header = TweetHeaderTemplate({
    mode: mode,
    presentation: presentation,
    publicKey: tweet.publicKey || '',
    name: tweet.username || '',
    handle: handle,
    time: mode === 'compose' ? '' : time,
    secondary: options.secondary != null ? String(options.secondary) : ''
  });
  var body = TweetBodyTemplate({
    text: tweet.app && tweet.app.browser ? tweet.app.browser.sanitize(tweet.app.browser.markupMentions((tweet === null || tweet === void 0 ? void 0 : tweet.text) || ''), true) : ''
  });
  var gallery = TweetGalleryTemplate({
    images: tweet.images
  });
  var youtubeId = String(tweet.youtube_id || '').replace(/[^A-Za-z0-9_-]/g, '');
  var youtube = youtubeId && youtubeId !== 'null' ? "<iframe class=\"youtube-embed\" src=\"https://www.youtube.com/embed/".concat(youtubeId, "\" allowfullscreen></iframe>") : '';
  var linkPreview = typeof tweet.renderLinkPreviewHTML === 'function' ? tweet.renderLinkPreviewHTML() : '';
  var embed = '';
  if (allowEmbed && tweet.embedded) {
    embed = "\n      <div class=\"embed\">\n        ".concat(_TweetTemplate(tweet.embedded, 'tweet embedded', {
      presentation: 'embedded',
      embedded: true,
      allowEmbed: false
    }), "\n      </div>\n    ");
  }
  var footer = hideControls ? '' : TweetFooterTemplate({
    replies: tweet.replies,
    retweets: tweet.retweets,
    likes: tweet.likes
  });
  var chain = embedded ? '' : '<div class="chain" aria-hidden="true"></div>';
  var showMask = Boolean(tweet.flagged === 1) || Boolean(tweet.moderated && !tweet.moderated_revealed);
  var maskText = tweet.flagged === 1 ? 'This tweet has been reported and is under review' : 'This tweet has been moderated';
  var showReveal = tweet.flagged !== 1 && tweet.moderated && !tweet.moderated_revealed;
  var moderationMask = showMask ? "\n      <div class=\"moderation-mask\">\n        <div class=\"moderation-message\">\n          <span class=\"text\">".concat(maskText, "</span>\n          ").concat(showReveal ? '<button type="button" class="saito-button-secondary small show-tweet">Show Tweet</button>' : '', "\n        </div>\n      </div>\n    ") : '';
  return "\n    <article class=\"".concat(className, "\" data-id=\"").concat(escapeAttribute(tweet.signature), "\">\n      ").concat(chain, "\n      <img class=\"avatar saito-identicon\" src=\"").concat(escapeAttribute(tweet.avatar), "\" alt=\"").concat(escapeAttribute(tweet.username), "\" data-id=\"").concat(escapeAttribute(tweet.publicKey || ''), "\" />\n      <div class=\"content\">\n        ").concat(header, "\n        ").concat(body, "\n        ").concat(gallery, "\n        ").concat(youtube, "\n        ").concat(linkPreview, "\n        ").concat(embed, "\n        ").concat(footer, "\n      </div>\n      ").concat(moderationMask, "\n    </article>\n  ");
};
_TweetTemplate.resolvePresentation = resolvePresentation;
_TweetTemplate.formatPublicKey = formatPublicKey;
_TweetTemplate.formatHandle = formatHandle;
_TweetTemplate.resolveHeaderMode = resolveHeaderMode;
module.exports = _TweetTemplate;